import React, { Component, PropTypes } from 'react';
import { StoreOverviewActions } from 'actions';
import { StoreOverviewStore, AuthStore } from 'stores';
import Loader from 'components/Material/Loader';
import { mixin, RefluxMixin } from 'Util';
import StoreItem from 'components/Store/StoreItem';
import { history } from 'helpers';
import { getSelectedItem } from 'selectors/store';

class StoreItemContainer extends mixin(RefluxMixin, Component) {
  static propTypes = {
    params: PropTypes.object,
    route: PropTypes.object
  };

  listenToStores() {
    this.listenToStoreWithMapper(StoreOverviewStore, state => ({
      loading: !state.selected || state.loading,
      themeColor: state.theme.color,
      logoUrl: state.theme.logoUrl,
      canIEdit: state.canIEdit,
      store: state.name,
      item: getSelectedItem(state),
      owner: state.owner
    }));
    this.listenToStoreWithMapper(AuthStore, state => ({
      loggedIn: state.loggedIn
    }));
  }

  componentDidMount() {
    const { username, slug } = this.props.params;
    const { type } = this.props.route;
    StoreOverviewActions.start(username, type, slug);
  }

  render() {
    const purchase = this.props.params.purchase === 'purchase';
    const { username } = this.props.params;

    const { item, loggedIn, loading, owner } = this.state;

    if (!item || loading) {
      return <Loader />;
    }

    return (
      <StoreItem
        userLocale={owner.locale}
        userName={username}
        loggedIn={loggedIn}
        purchase={purchase}
        {...this.state}
        history={history}
      />
    );
  }
}

export default StoreItemContainer;



// WEBPACK FOOTER //
// ./src/js/containers/Store/StoreItem.js